module.exports = __webpack_public_path__ + "media/images/flags/32/Montenegro-fba4ecd983b511204c5833d9c75a96e3.png";